import { motion, useReducedMotion } from "framer-motion";

// Subtle, on-view fade + slight upward entrance. Respects reduced motion.
export function Reveal({ children, delay = 0, y = 22, className = "", as }) {
  const reduce = useReducedMotion();
  const MotionTag = as ? motion[as] : motion.div;

  if (reduce) {
    const Tag = as || "div";
    return <Tag className={className}>{children}</Tag>;
  }

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
}

// Staggered container for grouped reveals
export function RevealGroup({ children, className = "", delayStep = 0.08 }) {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <div className={className}>
      {Array.isArray(children)
        ? children.map((child, i) => (
            <Reveal key={i} delay={i * delayStep}>
              {child}
            </Reveal>
          ))
        : children}
    </div>
  );
}
